import React from 'react';

import kebabCase from 'lodash/kebabCase';

import { Text } from '@change/ds-core-ui';
import { CheckIcon } from '@change/ds-icons';

import type { TaskShape } from '../../../../types';

type CompletedTaskProps = Pick<TaskShape, 'name' | 'title' | 'description'>;
export function CompletedTask({ name, title, description }: CompletedTaskProps): React.JSX.Element {
	return (
		<div data-qa="petition-task">
			<div className="flex gap-4 md:gap-6">
				<div
					className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full"
					sx={{
						backgroundColor: 'var(--color-icon-success, #EEFFF5)',
						border: '1px solid var(--color-stroke-success-weak, #0DDA62)',
					}}
				>
					<CheckIcon size={24} className="text-icon-success" />
				</div>
				<div className="flex w-full flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
					<div className="flex flex-col gap-1">
						<Text
							data-qa={`task-title-${kebabCase(name)}`}
							variant="heading"
							size="x-small"
							className="text-size-body-bold text-typography-weak md:text-size-heading-xs"
							as="h3"
						>
							{title}
						</Text>
						<Text
							data-qa={`task-description-${kebabCase(name)}`}
							variant="body"
							size="small"
							className="text-typography-weak"
							as="p"
						>
							{description}
						</Text>
					</div>
					<div className="min-w-[114px] shrink-0"></div>
				</div>
			</div>
		</div>
	);
}
